import { useCallback, useEffect, useState } from 'react';
import { datKhiHetPhien, datToken, goi, layToken } from './chung/api';
import { DangNhap } from './chung/DangNhap';
import { DaiMatKetNoi, NhaKetNoi } from './chung/KetNoi';
import { ThanhTren } from './chung/ThanhTren';
import { ThanhTichNho } from './chung/ThanhTichNho';
import { ManAdmin } from './admin/ManAdmin';
import { ManTuVan } from './nhan-vien/ManTuVan';
import { ManThuNgan, SoHomNay } from './thu-ngan/ManThuNgan';
import type { NguoiDung } from './chung/kieu';

/**
 * VAI QUYET DINH MAN HINH, khong phai ten mien.
 *
 * Ba ten mien phu (seller. cashier. admin.) deu tro vao CUNG mot ban dung; ai
 * dang nhap thi thay man cua vai do. Don gian hon han viec dung ba ban rieng, va
 * khong bao gio lech: thu ngan mo nham seller.colordistrict.vn van vao dung man
 * thu ngan thay vi mot man hinh ho khong dung duoc.
 *
 * Ma cua ca ba man deu tai ve may — o quy mo nay la vai chuc KB, va API van
 * cuong che quyen nen khong ro ri du lieu gi.
 */
export default function App() {
  const [nguoiDung, datNguoiDung] = useState<NguoiDung | null>(null);
  const [dangKiem, datDangKiem] = useState(true);

  const thoat = useCallback(() => {
    datToken(null);
    datNguoiDung(null);
  }, []);

  useEffect(() => {
    datKhiHetPhien(() => datNguoiDung(null));
    if (!layToken()) {
      datDangKiem(false);
      return;
    }
    // Con token thi hoi lai xem no con song khong. Tai khoan bi khoa giua ca thi
    // buoc nay tra 401 ngay — da chot: khoa co hieu luc lap tuc.
    goi<NguoiDung>('/api/auth/toi')
      .then(datNguoiDung)
      .catch(() => datToken(null))
      .finally(() => datDangKiem(false));
  }, []);

  // Trong luc kiem token: de trang. Hien mot khung xuong o day thi no chi nhap
  // nhay mot phan giay roi bien mat — nhieu hon la giup.
  if (dangKiem) return <div style={{ height: '100%' }} />;

  if (!nguoiDung) return <DangNhap xong={datNguoiDung} />;

  return (
    <NhaKetNoi>
      {/*
        Cả trang là MỘT MẶT BÀN, mọi thứ là vật đặt trên đó — nên có lề quanh
        viền và khe hở giữa các tấm. Dán sát mép thì bóng bị cắt cụt và vật mất
        cảm giác nổi, tức là mất luôn thứ duy nhất phân tách các vùng ở phong
        cách này.
      */}
      <div
        style={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: 14,
          padding: 14,
        }}
      >
        <DaiMatKetNoi />
        <ThanhTren
          nguoiDung={nguoiDung}
          thoat={thoat}
          giua={
            // 🔴 Bảng số đầy đủ có DOANH THU CỬA HÀNG, nên chỉ thu ngân và quản
            //    lý thấy. `/api/bao-cao/hien-tai` cũng chặn hai vai kia, nên để
            //    hiện thì thanh trên chỉ còn là một dải lỗi 403 chạy lại mỗi
            //    2,5 giây.
            //
            //    Nhân viên tư vấn được thấy THÀNH TÍCH CỦA CHÍNH MÌNH —
            //    `/api/bao-cao/thanh-tich` mở cho mọi vai và chỉ trả về phần của
            //    người gọi, không lộ số của ai khác.
            nguoiDung.vaiTro === 'CASHIER' || nguoiDung.vaiTro === 'ADMIN' ? (
              <SoHomNay />
            ) : nguoiDung.vaiTro === 'SELLER' ? (
              <ThanhTichNho />
            ) : undefined
          }
        />
        {nguoiDung.vaiTro === 'SELLER' && <ManTuVan />}
        {nguoiDung.vaiTro === 'CASHIER' && <ManThuNgan />}
        {/* Quản lý kho dùng CHUNG màn quản lý — `ManAdmin` tự lọc bớt mục theo
            vai, thay vì dựng một màn thứ tư gần giống hệt rồi lệch dần. */}
        {(nguoiDung.vaiTro === 'ADMIN' || nguoiDung.vaiTro === 'WAREHOUSER') && (
          <ManAdmin toi={nguoiDung} />
        )}
      </div>
    </NhaKetNoi>
  );
}
